export default "__VITE_ASSET__Bqxwu75O__"